import _ from 'lodash';

import { jsonParse } from 'utils/json';

export const parseQueryFilters = (search, filterFields) => {
  const params = new URLSearchParams(search);

  return Object.values(filterFields).reduce((acc, field) => {
    const raw = params.get(field);

    if (_.isNil(raw)) {
      return acc;
    }

    try {
      acc[field] = jsonParse(raw);
    } catch {
      acc[field] = raw;
    }

    return acc;
  }, {});
};
